import { render, staticRenderFns } from "./Proveedor_cotizacion.vue?vue&type=template&id=2b44c688&lang=pug&"
import script from "./Proveedor_cotizacion.vue?vue&type=script&lang=js&"
export * from "./Proveedor_cotizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports